// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'

// props
export interface CaptionSectionProps {
   captionLabel?: string
   caption?: string
   /** Shown below the caption (e.g. photo credit / copyright) */
   copyright?: string
}

export default function CaptionSection({ captionLabel, caption, copyright }: CaptionSectionProps) {
   return (
      <Section
         paddingBottom='small'
      >
         <div className='container'>
            <div className='row'>
               <div className='col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2'>
                  {caption && (
                     <p className='caption-section'>
                        {captionLabel && <span>{captionLabel}:&nbsp;</span>}
                        <span>{caption}</span>
                     </p>
                  )}
                  {copyright && (
                     <p className='caption-section caption-section--copyright'>
                        <b>©</b>{' '}
                        {copyright}
                     </p>
                  )}
               </div>
            </div>
         </div>
      </Section>
   )
}